"use client";

import { useCompanyData } from "@/app/(site)/_hooks/useSanityData";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

export default function WhatsappFixedBtn() {
	const [mounted, setMounted] = useState(false);
	const { companyInfo } = useCompanyData();

	const phoneNumber = companyInfo.phoneNumber?.split(" ").join("").replace("+", "");
	const message = "Hi, I'm interested in your services";

	const handleClick = () => {
		const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
		window.open(url, "_blank");
	};

	useEffect(() => {
		setMounted(true);
	}, []);

	if (!mounted) return null;

	return createPortal(
		<>
			<button
				className="fixed right-[1.875rem] bottom-10 z-50 size-[3.25rem] cursor-pointer rounded-full bg-black text-white transition-all duration-300 ease-out hover:scale-110 hover:bg-gray-800 hover:shadow-lg active:scale-95 active:bg-gray-900 active:shadow-xl"
				onClick={handleClick}
				aria-label="Open WhatsApp"
			>
				<div className="flex items-center justify-center">
					<svg xmlns="http://www.w3.org/2000/svg" width="23" height="27" viewBox="0 0 23 27" fill="none">
						<path
							d="M19.5469 0.164062C21.2037 0.164062 22.5469 1.50721 22.5469 3.16406V26.1641L16.5469 23.1641H3.54688C1.89002 23.1641 0.546875 21.8209 0.546875 20.1641V3.16406C0.546875 1.50721 1.89002 0.164063 3.54688 0.164062H19.5469Z"
							fill="#DCDCDC"
						/>
						<path
							d="M3.54688 18.1641C4.61354 18.8307 7.81354 20.1641 12.0802 20.1641C16.3469 20.1641 18.8358 18.8307 19.5469 18.1641"
							stroke="#1F1F1F"
							strokeWidth="1.5"
							strokeLinecap="round"
						/>
					</svg>
				</div>
			</button>
		</>,
		document.querySelector(".page-content") || document.body,
	);
}
